const breakpointValues = {
  "3xs": 375,
  "2xs": 424,
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  nav: 1280,
  xl: 1280,
  "2xl": 1536,
};

export const breakpoints = Object.entries(breakpointValues).reduce(
  (acc, [key, value]) => {
    acc[key] = {
      value,
      up: window.matchMedia(`(min-width: ${value}px)`),
      down: window.matchMedia(`(max-width: ${value - 1}px)`),
    };

    return acc;
  },
  {},
);
